import { render, staticRenderFns } from "./VipLookup.vue?vue&type=template&id=1b70feb8&lang=pug"
import script from "./VipLookup.vue?vue&type=script&lang=js"
export * from "./VipLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports